import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useWishlistStore = defineStore('wishlist', () => {
    const items = ref<string[]>([]) // Store product IDs

    // Load from local storage on init
    const saved = localStorage.getItem('wishlist')
    if (saved) {
        try {
            items.value = JSON.parse(saved)
        } catch (e) {
            console.error('Failed to parse wishlist', e)
        }
    }

    const count = computed(() => items.value.length)

    function save() {
        localStorage.setItem('wishlist', JSON.stringify(items.value))
    }

    function addItem(productId: string) {
        if (!items.value.includes(productId)) {
            items.value.push(productId)
            save()
        }
    }

    function removeItem(productId: string) {
        const index = items.value.indexOf(productId)
        if (index > -1) {
            items.value.splice(index, 1)
            save()
        }
    }

    function toggleItem(productId: string) {
        if (items.value.includes(productId)) {
            removeItem(productId)
        } else {
            addItem(productId)
        }
    }

    function hasItem(productId: string) {
        return items.value.includes(productId)
    }

    function clear() {
        items.value = []
        save()
    }

    return {
        items,
        count,
        addItem,
        removeItem,
        toggleItem,
        hasItem,
        clear,
    }
})
